import './js/scaleRoot.2.js';
import './js/scrollFrame.2.js';
import { MJPromotion } from './js/promotion2.js'

import lozad from 'lozad';

class Boot {
  getElementsDevice() {
    const elPc = $('.MS__pc');
    const elMb = $('.MS__mb');
    const isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;
    if (isMobile) {
      elPc.remove();
      console.log('Remove MS__pc:', elPc.length);
    } else {
      elMb.remove();
      console.log('Remove MS__mb:', elMb.length);
    };
  };
  removeLayerLoading() {
    setTimeout(() => {
      $('.MS__layer-loading, .layer').hide();
      console.log('Element Layer hidden');
    }, 4000);
  }
  onScale(callback) {
    $("#MS__wrapper, .MS__outer").addClass("scaleDesktop scaleMobile");
    window.addEventListener("load", function () {
      console.log('HTML,CSS,JS loaded');
      $("#MS__wrapper, .MS__outer").scalePlatform(callback);

    });
    $(window).on("resize", function () {
      $("#MS__wrapper, .MS__outer").scalePlatform();
    });

    let $firstImg;
    const isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;
    if (isMobile) {
      $firstImg = $('#MS__wrapper section .background img.MS__mb').first();
    } else {
      $firstImg = $('#MS__wrapper section .background img.MS__pc').first();
    }

    if (!$firstImg || $firstImg.length === 0) {
      console.warn('No first image found, skipping applySize logic.');
      return;
    }

    function applySize() {
      $('.MJ__readyScale').css({
        position: 'relative',
        zIndex: '10',
        width: $firstImg.width() + 'px',
        height: $firstImg.height() + 'px'
      });
      $("#MS__wrapper, .MS__outer").scalePlatform();
      console.log('First image loaded - scalePlatform triggered');
    }

    if ($firstImg[0].complete) {
      applySize(); // ảnh đã load sẵn
    } else {
      $firstImg.on('load', applySize); // chờ load mới xử lý
    }


  };
  async lazyLoad() {
    console.log("Found elements lazyloads:", $('.MS__lazyload, .MJ__lazyload').length);
    const observer = lozad('.MS__lazyload, .MJ__lazyload', {
      loaded: function (el) {
        el.classList.add('MJ__loaded', 'MJ__lazyload');

      }
    });
    observer.observe();
    console.log("Lozad loaded successfully");
  };
  async disableHref() {
    $('a[href="#"]').on('click', function (event) {
      var hrefValue = $(this).attr('href');
      if (hrefValue === '#') {
        event.preventDefault();
      }
    });
  };
  loadBundles() {
    const listBundles = varMS.bundles;

    const loadScript = (src, globalVar) => {
      if (window[globalVar]) {
        console.log(`${globalVar} already loaded from CDN`);
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => {
        console.log(`${globalVar} loaded successfully`);
      };
      script.onerror = () => console.error(`Failed to load ${src}`);
      document.head.appendChild(script);
    };

    const loadCSS = (href) => {
      if (document.querySelector(`link[href="${href}"]`)) {
        console.log(`CSS already loaded: ${href}`);
        return;
      }
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = () => {
        console.log(`CSS loaded: ${href}`);
      };
      link.onerror = () => console.error(`Failed to load CSS: ${href}`);
      document.head.appendChild(link);
    };

    for (const key in listBundles) {
      if (listBundles[key] === false) continue;
      try {
        switch (key) {
          case 'jquery':
            window.$ = jQuery;
            break;
          case 'lodash':
            loadScript("https://global-mainsite.mto.zing.vn/products/libraryMainsite/vendor/lodash.min.js", "_");
            break;
          case 'swiper':
            loadScript("https://global-mainsite.mto.zing.vn/products/libraryMainsite/vendor/swiper-bundle.min.js", "Swiper");
            loadCSS("https://global-mainsite.mto.zing.vn/products/libraryMainsite/vendor/swiper-bundle.min.css");
            break;
          case 'fancybox':
            loadScript("https://global-mainsite.mto.zing.vn/products/libraryMainsite/vendor/fancybox.umd.min.js", "Fancybox");
            loadCSS("https://global-mainsite.mto.zing.vn/products/libraryMainsite/vendor/fancybox.min.css");
            break;
          case 'animate':
            loadCSS("https://global-mainsite.mto.zing.vn/products/libraryMainsite/vendor/animate.min.css");
            break;
        }
      } catch (error) {
        console.error(`Failed to load ${key} from CDN:`, error);
      }
    }
  }
  run() {
    this.loadBundles();
    this.getElementsDevice()
    this.removeLayerLoading();
    this.onScale(() => new libraryMJ().loadVideo())
    this.disableHref();
    this.lazyLoad();
  }
};
class libraryMJ {
  onClosePopup() {
    $('.MJ__close-popup').on('click', function (e) {
      $(this).closest('.MS__popup').removeClass("active");
      return false;
    });
  };
  onToogleActive() {
    $(".MJ__toogleActive").on("click", function (e) {
      const target = $(this).data("target");
      $(target).toggleClass("active");
      e.preventDefault();
      return false;
    });
  };
  onOpenIframe() {
    $('.MJ__openIframe').on("click", function (e) {
      const linkIframe = $(this).data("link");
      const targetIframe = $(this).data("iframe");
      $(targetIframe).attr('src', linkIframe);
      e.preventDefault();
      return false;
    });
  };
  loadVideo() {
    const listVideos = $('.MJ__loadVideo');
    if (listVideos.length === 0) return;

    listVideos.each(function (index, element) {
      const $this = $(this);

      // Nếu đã có thẻ <video> bên trong thì bỏ qua
      if ($this.find('video').length > 0) return;

      const videoSrc = $this.data('video');
      $this.append(`
      <video width="100%" height="auto" playsinline muted autoplay loop loading="lazy" style="position: absolute; top: 0; left: 0;">
        <source src="${videoSrc}">
      </video>
    `);
    });
  }
  run() {
    this.onClosePopup();
    this.onToogleActive();
    this.onOpenIframe();
  }
};
class Core {
  constructor() {
    this.init();
  };
  promotion(object) {
    new MJPromotion(object);
  };
  init() {
    new Boot().run()
    new libraryMJ().run()
  };
}

window.libraryMainsite = new Core();
// Expose base classes for external module inheritance
window.__LibraryBase = { Boot, libraryMJ, Core };

// Auto-load all JS modules placed inside ./modules (e.g., testModule.js)
// This uses webpack's require.context. If a bundler without this feature is used,
// adapt to dynamic import logic.
try {
  const req = require.context('./modules', true, /\.js$/);
  req.keys().forEach(k => {
    try {
      req(k);
      console.log('[libraryMainsite] Module loaded:', k);
    } catch (modErr) {
      console.error('[libraryMainsite] Failed loading module', k, modErr);
    }
  });
} catch (e) {
  console.warn('[libraryMainsite] Module auto-load skipped (require.context not available)', e);
}
